import { mergeObjects } from 'app/app/common/ramda-utils'
import { Offer } from 'app/types/types'
import moment from 'moment'

export const setOfferModified = (offer: Offer) =>
  mergeObjects(offer, {
    modified_client: moment.utc().locale('en').format(),
    completed: false,
    finalizationProgress: {}
  })
